<template>
  <div class="system-builder__canadian--container">
    <p>
      If you’d like to find an Authorized Compustar dealer near you in Canada, please contact one of our regional distributors listed below.</p>
    <p>
      <strong>Western Canadian &amp; Ontario Customers</strong><br>
      Please contact Staub Electronics, LTD.<br>
      Toll-Free – <a href="tel:+18884702211" class="text__link--blue">1(888)470-2211</a><br>
      Website – <a href="https://www.staub.ca/" target="_blank" class="text__link--blue">www.Staub.ca</a>
    </p>
    <p>
      <strong>Eastern Canadian Customers</strong><br>
      Please contact Robert Thibert, Inc.<br>
      Toll-Free – <a href="tel:+18002681062" class="text__link--blue">1(800)268-1062</a><br>
      Website – <a href="http://www.rthibert.com/en-ca/" target="_blank"
                   class="text__link--blue">www.RThibert.com</a>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'canadianContact',
    data () {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// CanadianContact.vue?2530f5bd